import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);

let swiperOptions;
swiperOptions = {
   grabCursor: true,
   loop: true,
   pagination: {
      clickable: true,
   },
   on: {
      autoHeight: true,
   },
   breakpoints: {
      1300: {
         slidesPerView: 3,
         spaceBetween: 30,
      },
      992: {
         slidesPerView: 3,
         spaceBetween: 30,
      },
      768: {
         slidesPerView: 2,
         spaceBetween: 30,
      },
      0: {
         slidesPerView: 1,
         spaceBetween: 30,
      }
   }
};

let reviewsSwiperOptions = Object.assign({}, swiperOptions);
reviewsSwiperOptions['pagination']['el'] = '.rev-pagination';
reviewsSwiperOptions['navigation'] = {
   prevEl: '.rev-prev',
   nextEl: '.rev-next',
};
let reviewsSwiper = new Swiper('.rev-slider', reviewsSwiperOptions);

let partnersSwiperOptions = Object.assign({}, swiperOptions);
partnersSwiperOptions['pagination']['el'] = '.partners-pagination';
partnersSwiperOptions['navigation'] = {
   prevEl: '.partners-prev',
   nextEl: '.partners-next',
};

let partnersSwiper = new Swiper('.partners-slider', partnersSwiperOptions);

let newsSwiperOptions = Object.assign({}, swiperOptions);
newsSwiperOptions['pagination']['el'] = '.news-pagination';
newsSwiperOptions['navigation'] = {
   prevEl: '.news-prev',
   nextEl: '.news-next',
};
let newsSwiper = new Swiper('.slider-news', newsSwiperOptions);
